/**
 * Shared client-side viem public client.
 *
 * Several hooks (`useWallet`, live balance pollers, price pollers, etc.)
 * previously re-built a `PublicClient` on every call — which re-allocates
 * the HTTP transport and its batch scheduler. Hoisting a single instance
 * here gives all client hooks a shared, multicall-batched transport.
 *
 * NOTE: This module is client-safe (uses `NEXT_PUBLIC_*` env). Server
 * routes must use `src/lib/viem-server.ts` instead so the private
 * `RPC_URL` isn't leaked into the browser bundle.
 */

import { createPublicClient, http, type PublicClient } from 'viem';
import { base, baseSepolia } from 'viem/chains';

const chainId = process.env.NEXT_PUBLIC_CHAIN_ID;
export const clientChain = chainId === '8453' ? base : baseSepolia;

const rpcUrl = process.env.NEXT_PUBLIC_RPC_URL || clientChain.rpcUrls.default.http[0];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const clientPublicClient: PublicClient<any, any> = createPublicClient({
  chain: clientChain,
  transport: http(rpcUrl, {
    batch: { batchSize: 100, wait: 0 },
  }),
  batch: {
    multicall: true,
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
}) as PublicClient<any, any>;
